"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const DynamicSchemaDefinition_1 = require("./DynamicSchemaDefinition");
class DynamicSchemaValue {
    constructor({ definition, values }) {
        this.getValue = (key) => this.values.get(key, null);
        this.setValue = (key, value) => new DynamicSchemaValue({ definition: this.definition, values: this.values.set(key, value) });
        this.adaptForAnotherDefinition = (definition) => {
            const fields = definition.sections.flatMap(section => section.fields);
            const values = immutable_1.Map(fields.map(field => {
                if (field instanceof DynamicSchemaDefinition_1.Files) {
                    return [field.key, field.getDefaultValue()];
                }
                return [field.key, field.getAdaptedValue(this.values.get(field.key))];
            }));
            return new DynamicSchemaValue({ definition, values });
        };
        this.toJSON = () => {
            return this.values
                .mapEntries(([fieldKey, value]) => {
                if (value instanceof immutable_1.Set) {
                    return [fieldKey, value.toArray()];
                }
                return [fieldKey, value];
            })
                .toJSON();
        };
        this.definition = definition;
        this.values = values;
    }
}
DynamicSchemaValue.fromJSONAndDefinition = (json, definition) => {
    const fields = definition.sections.flatMap(section => section.fields);
    const values = immutable_1.Map(fields.map(field => {
        const value = field.type === 'SELECT_MULTIPLE' ? immutable_1.Set(json[field.key]) : json[field.key];
        return [field.key, field.getAdaptedValue(value)];
    }));
    return new DynamicSchemaValue({ definition, values });
};
DynamicSchemaValue.createWithDefinition = (definition) => DynamicSchemaValue.fromJSONAndDefinition({}, definition);
exports.default = DynamicSchemaValue;
